export const NationalRegisterNumberOptOut = Symbol.for('nationalRegisterNumberOptOut');
//# sourceMappingURL=NationalRegisterNumberOptOut.js.map